import SettingsIcon from "@mui/icons-material/Settings";
import styles from "./SettingsButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
}

export const SettingsButton = ({ className, onClick }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""}`} onClick={onClick}>
            <SettingsIcon />
            <div>{"Developer settings"}</div>
        </div>
    );
};
